import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { GlowService } from 'src/app/services/glow.service';
import { FormValidator } from 'src/app/services/user-validators';

@Component({
  selector: 'app-cad-waitlist',
  templateUrl: './cad-waitlist.component.html',
  styleUrls: ['./cad-waitlist.component.scss']
})
export class CadWaitlistComponent implements OnInit {

  contactForm: FormGroup
  submitMessage = ''
  reasonOptions = ['Application Reseller', 'Consulting', 'Distributor', 'Media', 'Product Demo', 'Retailer', 'SaaS Reseller', 'Speaking', 'Other']
  successful: boolean = false
  unsuccessful: boolean = false
  date = new Date().toLocaleDateString("en-GB")
  constructor(private fb: FormBuilder, private translate: TranslateService, private glow: GlowService) {
    this.contactForm = this.fb.group({
      email: ['', [Validators.required, FormValidator.isEmailValid]],
      smetsVariant: [1, [Validators.required]],

    })
  }

  ngOnInit() {

  }

  checkFormValidity(formControlName, translateKey?) {
    let messages = []
    let formFieldName = ''
    translateKey ? formFieldName = (this.translate.instant(translateKey)) : null

    //check if form control has extra validators and user has begun typing

    if (formControlName == 'email') {
      if (this.contactForm.get(formControlName).errors && this.contactForm.get(formControlName).dirty && this.contactForm.get(formControlName).value.length) {
        const errors = this.contactForm.get(formControlName).errors;
        Object.values(errors).forEach((v) => {
          v.errMsg ? (messages = [...messages, v.errMsg]) : null;
        });
        return messages
        //if it has extra validators and is required
      } else if (this.contactForm.get(formControlName).errors && this.contactForm.get(formControlName).touched && !this.contactForm.get(formControlName).valid && !this.contactForm.get(formControlName).value.length && this.contactForm.get(formControlName).errors.required) {
        const errorMsg = `${formFieldName} is required.`
        messages = [errorMsg]
        return messages
      }
    }
    //no extra validators but required
    else if (this.contactForm.get(formControlName).touched && !this.contactForm.get(formControlName).valid && this.contactForm.get(formControlName).errors.required) {
      const errorMsg = `${formFieldName} is required.`
      messages = [errorMsg]
      return messages

    }

    return
  }

  markFormGroupTouched(formGroup: FormGroup,) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();

    });
  }

  submit() {
    if (this.contactForm.valid) {
      const body = {
        email: this.contactForm.get('email').value,
        custom_fields: {
          "e2_N": Number(this.contactForm.get('smetsVariant').value)
        }
      }
      console.log(body)
      this.glow.addUserToWaitList(body).subscribe({
        next: (response) => {
          console.log(response);
          if (response.valid) {
            this.submitMessage = 'Thank you for registering your interest in our Display CAD. We\'ll share key updates with you when we have them. We hope to have units available in the Autumn of 2026.';
            this.successful = true;
            this.contactForm.reset();
          } else {
            this.submitMessage = 'An error occurred. Please try again later.';
            this.unsuccessful = true;
          }
        },
        error: (error) => {
          console.error('Request failed:', error);
          this.submitMessage = 'An error occurred. Please try again later.';
          this.unsuccessful = true;
        }
      })
    }
  }
    }
